"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const react_intl_1 = require("react-intl");
const react_hook_form_1 = require("react-hook-form");
const provider_test_id_1 = require("@framework/provider-test-id");
const AutocompleteInput = props => {
    const { disableClear, disabled, name, label, options, multiple, readOnly, variant = "standard" } = props;
    const { testId } = (0, provider_test_id_1.useTestId)();
    const testIdProps = testId ? { "data-testid": `${testId}-${name}` } : {};
    const suffix = name.split(".").pop();
    const form = (0, react_hook_form_1.useFormContext)();
    const error = (0, react_hook_form_1.get)(form.formState.errors, name);
    const value = (0, react_hook_form_1.useWatch)({ name });
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const localizedLabel = label === void 0 ? formatMessage({ id: `form.labels.${suffix}` }) : label;
    const localizedHelperText = error ? formatMessage({ id: error.message }, { label: localizedLabel }) : "";
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: name, control: form.control, render: ({ field }) => {
            if (multiple) {
                return ((0, jsx_runtime_1.jsx)(material_1.Autocomplete, { sx: { my: 1 }, multiple: true, options: options, disableClearable: disableClear || readOnly, disabled: disabled, value: options.filter((option) => value.includes(option.key)), onChange: (_event, values) => {
                        const newValue = values ? values.map((value) => value.key) : [];
                        form.setValue(name, newValue, { shouldDirty: true });
                    }, getOptionLabel: (option) => option.value, renderOption: (props, option) => {
                        return ((0, react_1.createElement)("li", { ...props, key: option.key }, option.value));
                    }, renderInput: (params) => ((0, jsx_runtime_1.jsx)(material_1.TextField, { ...field, ...params, inputProps: {
                            ...params.inputProps,
                            ...testIdProps,
                            readOnly,
                        }, onBlur: () => {
                            if (!readOnly) {
                                field.onBlur();
                            }
                        }, label: localizedLabel, placeholder: formatMessage({ id: `form.placeholders.${suffix}` }), error: !!error, helperText: localizedHelperText, variant: variant, fullWidth: true })) }));
            }
            else {
                return ((0, jsx_runtime_1.jsx)(material_1.Autocomplete, { sx: { my: 1 }, multiple: false, options: options, disableClearable: disableClear || readOnly, disabled: disabled, value: options.find((option) => value === option.key) || null, onChange: (_event, value) => {
                        const newValue = value ? value.key : null;
                        form.setValue(name, newValue, { shouldDirty: true });
                    }, getOptionLabel: (option) => option.value, renderOption: (props, option) => {
                        return ((0, react_1.createElement)("li", { ...props, key: option.key }, option.value));
                    }, renderInput: (params) => ((0, jsx_runtime_1.jsx)(material_1.TextField, { ...field, ...params, inputProps: {
                            ...params.inputProps,
                            ...testIdProps,
                            readOnly,
                        }, onBlur: () => {
                            if (!readOnly) {
                                field.onBlur();
                            }
                        }, label: localizedLabel, placeholder: formatMessage({ id: `form.placeholders.${suffix}` }), error: !!error, helperText: localizedHelperText, variant: variant, fullWidth: true })) }));
            }
        } }));
};
exports.AutocompleteInput = AutocompleteInput;
//# sourceMappingURL=index.js.map